import { axios } from '@/utils/request'

const api = {
    saiquList: '/wyhadminapi/huiyi/saiquList',
    sjsqOptions: '/wyhadminapi/huiyi/sjsqOptions',

    saiquDetail: '/wyhadminapi/huiyi/saiquDetail',
    editSaiqu: '/wyhadminapi/huiyi/editSaiqu',
    addSaiqu: '/wyhadminapi/huiyi/addSaiqu',

    addHuiyiFile: '/wyhadminapi/huiyi/filesadd',
    huiyiFileList: '/wyhadminapi/huiyi/fileslist',
    deleteHuiyiFile: '/wyhadminapi/huiyi/filesdelete',

    saijiList: '/wyhadminapi/huiyi/saijiList',
    saijiDetail: '/wyhadminapi/huiyi/saijiDetail',
    stationOptions: '/wyhadminapi/huiyi/stationOptions',
    editSaiji: '/wyhadminapi/huiyi/editSaiji',
    groupList: '/wyhadminapi/huiyi/groupList',


    serviceTypeList: '/wyhadminapi/huiyi/serviceTypeList',
    serviceTypeDetail: '/wyhadminapi/huiyi/serviceTypeDetail',
    addServiceType: '/wyhadminapi/huiyi/addServiceType',
    editServiceType: '/wyhadminapi/huiyi/editServiceType',
    serviceTypeDelete: '/wyhadminapi/huiyi/serviceTypeDelete',


    applyList: '/wyhadminapi/huiyi/applyList',
    applyareaList: '/wyhadminapi/huiyi/applyareaList',
    applyDetail: '/wyhadminapi/huiyi/applyDetail',
    editApply: '/wyhadminapi/huiyi/editApply',
    getApplyOrderDetail: '/wyhadminapi/huiyi/applyOrderDetail',
    editApplyOrder: '/wyhadminapi/huiyi/editApplyOrder',

    applySubjectList: '/wyhadminapi/huiyi/applySubjectList',
    applySubjectDetail: '/wyhadminapi/huiyi/applySubjectDetail',
    editApplySubject: '/wyhadminapi/huiyi/editApplySubject',


    applyDelete: '/wyhadminapi/huiyi/applyDelete',
    getSetting: '/wyhadminapi/huiyi/getSetting',
    setSetting: '/wyhadminapi/huiyi/setSetting',
    setCash: '/wyhadminapi/huiyi/setCash',
    getApplyUserDetail: '/wyhadminapi/huiyi/memberDetail',
    editApplyUser: '/wyhadminapi/huiyi/applyMemberEdit',

    saiquApplyStep2Detail: '/wyhadminapi/huiyi/saiquApplyStep2Detail',
    saiquApplyStep2Save: '/wyhadminapi/huiyi/saiquApplyStep2Save',


    addSaiquApply: '/wyhadminapi/huiyi/addSaiquApply',
    editSaiquApply: '/wyhadminapi/huiyi/editSaiquApply',
    getSaiquApplyList: '/wyhadminapi/huiyi/saiquApplyList',
    getSaiquApplyDetail: '/wyhadminapi/huiyi/saiquApplyDetail',
    saiquApplyDelete: '/wyhadminapi/huiyi/saiquApplyDelete',

    getXieyiList: '/wyhadminapi/huiyi/xieyiList',
    addXieyiFile: '/wyhadminapi/huiyi/addXieyiFile',
    getTypeOptions: '/wyhadminapi/huiyi/getTypeOptions',
    scoreImport: '/wyhadminapi/huiyi/scoreImport',
    cashDownloadUrl: '/wyhadminapi/huiyi/cashDownloadUrl',

}

export default api

export function getSaijiList(parameter) {
  return axios({
    url: api.saijiList,
    method: 'get',
    params: parameter
  })
}

export function getSaijiDetail(parameter) {
  return axios({
    url: api.saijiDetail,
    method: 'get',
    params: parameter
  })
}

export function editSaiji(parameter) {
  return axios({
    url: api.editSaiji,
    method: 'post',
    data: parameter
  })
}



export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}



export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}

export function addHuiyiFile(parameter) {
    return axios({
        url: api.addHuiyiFile,
        method: 'post',
        data: parameter
    })
}

export function getHuiyiFileList(parameter) {
    return axios({
        url: api.huiyiFileList,
        method: 'get',
        params: parameter
    })
}

export function deleteHuiyiFile(parameter) {
    return axios({
        url: api.deleteHuiyiFile,
        method: 'post',
        data: parameter
    })
}


export function getServiceTypeList(parameter) {
    return axios({
        url: api.serviceTypeList,
        method: 'get',
        params: parameter
    })
}


export function addServiceType(parameter) {
    return axios({
        url: api.addServiceType,
        method: 'post',
        data: parameter
    })
}

export function editServiceType(parameter) {
    return axios({
        url: api.editServiceType,
        method: 'post',
        data: parameter
    })
}
export function getServiceTypeDetail(parameter) {
    return axios({
        url: api.serviceTypeDetail,
        method: 'get',
        params: parameter
    })
}

export function serviceTypeDelete(parameter) {
    return axios({
        url: api.serviceTypeDelete,
        method: 'post',
        data: parameter
    })
}



export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}


export function getApplyAreaList(parameter) {
    return axios({
        url: api.applyareaList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}



export function getApplySubjectList(parameter) {
    return axios({
        url: api.applySubjectList,
        method: 'get',
        params: parameter
    })
}

export function applySubjectDetail(parameter) {
    return axios({
        url: api.applySubjectDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplySubject(parameter) {
    return axios({
        url: api.editApplySubject,
        method: 'post',
        data: parameter
    })
}


export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}


export function subjectOptions(parameter) {
    return axios({
        url: api.subjectOptions,
        method: 'get',
        params: parameter
    })
}
export function startListOptions(parameter) {
    return axios({
        url: api.startListOptions,
        method: 'get',
        params: parameter
    })
}
export function getStartList(parameter) {
    return axios({
        url: api.getStartList,
        method: 'get',
        params: parameter
    })
}
export function getJiaolianList(parameter) {
    return axios({
        url: api.jiaolianList,
        method: 'get',
        params: parameter
    })
}
export function getCaipanList(parameter) {
    return axios({
        url: api.caipanList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicList(parameter) {
    return axios({
        url: api.subjectMusicList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicDetail(parameter) {
    return axios({
        url: api.subjectMusicDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectMusic(parameter) {
    return axios({
        url: api.editSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function addSubjectMusic(parameter) {
    return axios({
        url: api.addSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function subjectMusicDelete(parameter) {
    return axios({
        url: api.subjectMusicDelete,
        method: 'post',
        params: parameter
    })
}


export function subjectTypeList(parameter) {
    return axios({
        url: api.subjectTypeList,
        method: 'get',
        params: parameter
    })
}
export function subjectTypeDetail(parameter) {
    return axios({
        url: api.subjectTypeDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectType(parameter) {
    return axios({
        url: api.editSubjectType,
        method: 'post',
        data: parameter
    })
}
export function addSubjectType(parameter) {
    return axios({
        url: api.addSubjectType,
        method: 'post',
        data: parameter
    })
}
export function subjectTypeDelete(parameter) {
    return axios({
        url: api.subjectTypeDelete,
        method: 'post',
        params: parameter
    })
}


export function setSetting(parameter) {
    return axios({
        url: api.setSetting,
        method: 'post',
        params: parameter
    })
}

export function setCash(parameter) {
    return axios({
        url: api.setCash,
        method: 'post',
        params: parameter
    })
}

export function getCashDownloadUrl(parameter) {
    return axios({
        url: api.cashDownloadUrl,
        method: 'post',
        params: parameter
    })
}

export function getSetting(parameter) {
    return axios({
        url: api.getSetting,
        method: 'post',
        params: parameter
    })
}


export function sjsqOptions(parameter) {
    return axios({
        url: api.sjsqOptions,
        method: 'post',
        params: parameter
    })
}
export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}

export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}

export function editApplyUser(parameter) {
    return axios({
        url: api.editApplyUser,
        method: 'post',
        data: parameter
    })
}
export function getApplyUserDetail(parameter) {
    return axios({
        url: api.getApplyUserDetail,
        method: 'post',
        data: parameter
    })
}
export function saiquApplyStep2Detail(parameter) {
    return axios({
        url: api.saiquApplyStep2Detail,
        method: 'get',
        params: parameter
    })
}

export function addSaiquApply(parameter) {
    return axios({
        url: api.addSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function editSaiquApply(parameter) {
    return axios({
        url: api.editSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function getSaiquApplyList(parameter) {
    return axios({
        url: api.getSaiquApplyList,
        method: 'get',
        params: parameter
    })
}
export function getSaiquApplyDetail(parameter) {
    return axios({
        url: api.getSaiquApplyDetail,
        method: 'get',
        params: parameter
    })
}
export function addXieyiFile(parameter) {
    return axios({
        url: api.addXieyiFile,
        method: 'post',
        data: parameter
    })
}
export function getXieyiList(parameter) {
    return axios({
        url: api.getXieyiList,
        method: 'post',
        data: parameter
    })
}
export function saiquApplyDelete(parameter) {
    return axios({
        url: api.saiquApplyDelete,
        method: 'post',
        data: parameter
    })
}
export function saiquApplyStep2Save(parameter) {
    return axios({
        url: api.saiquApplyStep2Save,
        method: 'post',
        data: parameter
    })
}
export function getTypeOptions(parameter) {
    return axios({
        url: api.getTypeOptions,
        method: 'post',
        data: parameter
    })
}


export function scoreImport(parameter) {
    return axios({
        url: api.scoreImport,
        method: 'post',
        headers: {
            'Content-Type':'multipart/form-data'
        },
        data: parameter
    })
}
 

export function getSaiquCashList(parameter) {
    return axios({
        url: '/wyhadminapi/huiyi/saiquCashList',
        method: 'post',
        data: parameter
    })
}
export function cashSaiqu(parameter) {
    return axios({
        url: '/wyhadminapi/huiyi/cashSaiqu',
        method: 'post',
        data: parameter
    })
}
export function getSaiquRewardList(parameter) {
    return axios({
        url: '/wyhadminapi/huiyi/saiquRewardList',
        method: 'post',
        data: parameter
    })
}
export function rewardEdit(parameter) {
    return axios({
        url: '/wyhadminapi/huiyi/rewardEdit',
        method: 'post',
        data: parameter
    })
}

export function getCashDetail(parameter) {
    return axios({
        url: '/wyhadminapi/huiyi/rewardDetail',
        method: 'post',
        data: parameter
    })
}

export function onHuiyiReward(parameter) {
    return axios({
        url: '/wyhadminapi/huiyi/onHuiyiReward',
        method: 'post',
        data: parameter
    })
}


export function stationOptions(parameter) {
    return axios({
        url: api.stationOptions,
        method: 'post',
        data: parameter
    })
}

export function getGroupList(parameter) {
    return axios({
        url: api.groupList,
        method: 'get',
        params: parameter
    })
}